<template>
  <SideMenuComponent :menu="menu" area="registration" />
  <div class="content-wrapper">
    <ErrorView v-if="errorStatus" />
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMainStore } from "@/store/main/main";
import ErrorView from "@/views/Error/ErrorView.vue";
import SideMenuComponent from "@/components/SideMenuComponent.vue";
import { useRegistrationStore } from "@/store/registration/registration";
import { useErrorStore } from "@/store/error/error";

export default {
  components: { SideMenuComponent, ErrorView },
  computed: {
    ...mapState(useRegistrationStore, {
      menu: (store) => store.menu,
    }),
    ...mapState(useErrorStore, {
      errorStatus: (store) => store.status,
    }),
    ...mapState(useMainStore, {
      isMobile: (store) => store.isMobile,
    }),
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.fetchMenu();
      if (!this.isMobile) {
        this.openSideBar();
      }
    },

    ...mapActions(useMainStore, {
      setAppLoading: "setAppLoading",
      openSideBar: "openSideBar",
    }),
    ...mapActions(useRegistrationStore, {
      fetchMenu: "fetchMenu",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
